import dayjs from 'dayjs';

export interface TimeInterval {
  milliseconds: number;
}

export function defaultTimeInterval(): TimeInterval {
  return {
    milliseconds: 0
  };
}

export function timeIntervalFromSeconds(seconds: number): TimeInterval {
  return { milliseconds: seconds * 1000 };
}

export function addTimeIntervalSeconds(interval: TimeInterval, seconds: number): TimeInterval {
  return { milliseconds: interval.milliseconds + seconds * 1000 };
}

export function addTimeIntervals(first: TimeInterval, second: TimeInterval): TimeInterval {
  const milliseconds = first.milliseconds + second.milliseconds;
  return {
    milliseconds
  };
}

export function timeIntervalToString(timespan: TimeInterval): string {
  return dayjs.duration(timespan.milliseconds).toISOString();
}

export function parseTimeInterval(value: string): TimeInterval | false {

  const parsed = dayjs.duration(value);
  const milliseconds = parsed.asMilliseconds();
  if (isNaN(milliseconds)) {
    return false;
  }
  return { milliseconds };
}
